import { render, staticRenderFns } from "./TrackingComment.vue?vue&type=template&id=5b676529"
import script from "./TrackingComment.vue?vue&type=script&lang=js"
export * from "./TrackingComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports